module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('a', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "dropdown-toggle clear",
    attrs: {
      "href": "javascript://",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    staticClass: "thumb-sm avatar pull-right m-t-n-sm m-b-n-sm m-l-sm"
  }, [(_vm.currentUser.foto) ? _c('img', {
    attrs: {
      "src": _vm.currentUser.foto,
      "alt": _vm.currentUser.nome
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../../assets/img/user-default.png")
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "on md b-white bottom"
  })]), _vm._v(" "), _c('b', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm"
  }, [_vm._v(_vm._s(_vm.currentUser.name && _vm.currentUser.name.split(' ')[0]))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated fadeInRight w"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_vm._v("Sair")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript://"
    }
  }, [_c('span', [_vm._v("Configurações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "ui-sref": "app.page.profile"
    }
  }, [_vm._v("Perfil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "ui-sref": "app.docs"
    }
  }, [_vm._v("Ajuda ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc7648aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/header/Profile.vue
// module id = 1892
// module chunks = 17